import React, { useEffect, useState } from 'react'
import Button from 'react-bootstrap/Button';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { appliedExamsListGet, userExamDetailsDelete } from './JotSlice';
import Pagination from '../../../component/Pagination';
import StyledDataTable from '../../../component/resuable/StyledComponent';
import { format } from 'date-fns';
import LoadingSpinner from '../../../component/resuable/LoadingSpinner';
import { toast } from 'react-toastify';


const User_list = (props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const searchdata = props.search
    const filterdate = props.filter
    const filterByExamLevelValue = props.filterByExamLevelValue
    const filterByResultValue = props.filterByResultValue

    const [currentPage, setCurrentPage] = useState(1);
    const [rowData, setRowData] = useState([]);

    const JOT_DATA = useSelector(state => state.jot);
    const { appliedExamsList } = useSelector(state => state.jot);
    const appliedExamListData = appliedExamsList?.data;

    const pageSize = 10;

    const fetchAppliedExamList = () => {
        const filter = filterdate !== null ? filterdate : ""
        const search = searchdata !== undefined ? searchdata : ""
        const exam_level = filterByExamLevelValue
        const result_type = filterByResultValue
        const params = {
            page: currentPage,
            search,
            filter,
            exam_level,
            result_type
        }
        dispatch(appliedExamsListGet(params));
    }

    useEffect(() => {
        fetchAppliedExamList()
    }, [currentPage, searchdata, filterdate, filterByExamLevelValue, filterByResultValue])

    // Pass the exact exam (application_id) so a student's newer exam on the same day isn't mixed up
    const handleEditClick = (id, applied_date, application_id) => {
        navigate(`edit/${id}/${applied_date}?application_id=${application_id}`)
    }

    

    // DELETE /jot/exam/<id> keys off Exam.id (application_id), not the student's user_id
    const handleDeleteClick = (application_id, applied_date) => {
        if (application_id === undefined || application_id === null) {
            toast.error("Application id is missing. Please refresh and try again.")
            return
        }
        dispatch(userExamDetailsDelete(application_id)).then(res => {
            if (res?.payload?.status === 200) {
                toast.success(res?.payload?.data?.message)
                fetchAppliedExamList()
            } else {
                // Deletion is blocked from D-5 to exam day. apiDelete returns the
                // axios error itself, so the backend message is under .response.
                const errorData = res?.payload?.response?.data || res?.payload?.data
                toast.error(errorData?.message || errorData?.error || "Unable to delete the application.")
            }
        })
    }

    const columns = [
      {
        name: "S.No",
        selector: (row, index) => index + 1,
        sortable: true,
        width: "7%",
      },
      {
        name: "Name",
        selector: (row) => row.first_name,
        sortable: true,
        width: "10%",
      },
      {
        name: "Romaji Name",
        selector: (row) => row.romaji_name || "N/A",
        sortable: true,
        width: "10%",
      },
      {
        name: "Email",
        selector: (row) => row.email,
        sortable: true,
        width: "12%",
      },
      {
        name: "Exam Level",
        selector: (row) => row.exam_level,
        sortable: true,
        width: "11%",
      },
      {
        name: "Applied Date",
        selector: (row) =>
          row.applied_at !== null
            ? format(new Date(row.applied_at), "dd/MM/yyyy")
            : "N/A",
        sortable: true,
        width: "12%",
      },
      {
        name: "Exam Date",
        selector: (row) =>
          row.exam_date !== null
            ? format(new Date(row.exam_date), "dd/MM/yyyy")
            : "N/A",
        sortable: true,
        width: "12%",
      },
      {
        name: "Result",
        selector: (row) => (row.result !== null ? row.result : "N/A"),
        sortable: true,
        width: "7%",
      },
      {
        name: "Payment Status",
        cell: (row) => {
            const status = row.payment_status?.toLowerCase();
            
          const displayStatus = status
            ? status.charAt(0).toUpperCase() + status.slice(1)
            : "N/A";
          return (
            <span
              style={{
                backgroundColor:
                  status === "paid"
                    ? "#d4edda"
                    : status === "failed"
                      ? "#f8d7da"
                      : "#e2e3e5",
                color:
                  status === "paid"
                    ? "#155724"
                    : status === "failed"
                      ? "#721c24"
                      : "#383d41",
                padding: "6px 12px",
                borderRadius: "20px",
                fontWeight: "600",
                fontSize: "13px",
                display: "inline-block",
                minWidth: "70px",
                textAlign: "center",
              }}
            >
              {displayStatus}
            </span>
          );
        },
        sortable: true,
        width: "14%",
      },
      {
        name: "Action",
        cell: (row) => (
          <>
            {/* <Button className='table-viewcustom-button ' onClick={() => handleViewClick(row.user_id, row.applied_at)}><i class="fas fa-eye px-2"></i></Button> */}
            <Button
              className="table-viewcustom-button "
              onClick={() => handleEditClick(row.user_id, row.applied_at, row.application_id)}
            >
              <i class="fas fa-edit px-2"></i>
            </Button>
            <button
              type="button"
              class="table-custom-button m-1 btn btn-primary"
              onClick={() => {
                handleDeleteClick(row.application_id, row.applied_at);
              }}
            >
              <i class="fa fa-trash px-3"></i>
            </button>
            {/* <Button className='table-viewcustom-button ' onClick={() => handleDeleteClick(row.user_id, row.applied_at)}><i class="fas fa-delete px-2"></i></Button> */}
          </>
        ),
        button: true,
        width: "7%",
      },
    ];

    useEffect(() => {
        if (appliedExamListData && Array.isArray(appliedExamListData)) {
            const formattedData = appliedExamListData.map((data) => ({
                first_name: data.first_name + " " + data.last_name,
                romaji_name: data.romaji_name,
                email: data.email,
                gender: data.gender,
                exam_level: data.exam_level,
                payment_status: data.payment_status,
                applied_at: data.applied_at,
                exam_date: data.exam_date,
                result: data.result,
                applied_at: data.applied_at,
                user_id: data.user_id,
                application_id: data.application_id,
            }));
            setRowData(formattedData);
        }
    }, [appliedExamsList]);

    return (
        <>
            {JOT_DATA?.loading && <LoadingSpinner />}
            <div className='' >
                <div className="mt-2">
                    <StyledDataTable
                        columns={columns}
                        data={rowData.length > 0 ? rowData : []}
                        highlightOnHover
                        responsive
                          paginationDefaultPage={currentPage}
                        persistTableHead={true}
                    />
                </div>
            </div>


            <div >
                {appliedExamListData?.length > 0 ?
                    <Pagination
                        className="pagination-bar"
                        currentPage={appliedExamsList?.current_page}
                        totalCount={appliedExamsList?.no_of_records}
                        pageSize={pageSize}
                        onPageChange={(page) => setCurrentPage(page)}
                    />
                    :
                    ''
                }
            </div></>
    )
}

export default User_list